import React, { useEffect, useMemo, useRef } from 'react';
import { SubRollingOfferProps } from 'templates/RollingOffer/shared/types';
import { HugeSubRollingOffer } from './SubRollingOffer/HugeSubRollingOffer';
import {
  arrowHeightWidth,
  subOfferHeight,
} from 'templates/RollingOffer/shared/utils';
import { StyledSubOfferWrapper } from './style';
import { useStoreState } from 'state/hooks/store.state.hook';
import { observerElement } from 'components/StoreLayout/useObserver';
import { OfferData } from 'utils/types';

interface IRollingOfferColumnProps {
  subOffer: SubRollingOfferProps;
  index: number;
  isAnimating: boolean;
  width: number;
  isPreview: boolean;
  parentData: OfferData;
}

export const HugeSubRollingOfferWrapper: React.FC<IRollingOfferColumnProps> = ({
  subOffer,
  index,
  isAnimating,
  width,
  isPreview,
  parentData,
}) => {
  const { sendEvent } = useStoreState();
  const position = useMemo(() => {
    const row = Math.floor(index / 2);
    const col = row % 2 === 0 ? index % 2 : 1 - (index % 2); // 'snake' layout

    return {
      x: col && width + arrowHeightWidth,
      y: row * (subOfferHeight + arrowHeightWidth),
    };
  }, [index, width]);

  const itemRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!itemRef?.current || !sendEvent) return;
    observerElement(
      itemRef.current,
      {
        ...parentData,
        indexToCollect: parentData.indexToCollect
          ? parentData.indexToCollect + index
          : index + 1,
      },
      sendEvent,
      `${parentData.offerId}_${index + 1}`,
    );
  }, [itemRef?.current, sendEvent]);

  return (
    <StyledSubOfferWrapper
      ref={itemRef}
      layout
      key={subOffer.index}
      initial={position}
      animate={position}
      exit={{ opacity: 0, scale: 0 }}
      transition={{
        type: 'spring',
        stiffness: 50,
        mass: 0.9,
        damping: 10,
        duration: isPreview ? 0 : 0.2,
        delay: index * 0.04,
      }}
    >
      <HugeSubRollingOffer
        key={subOffer.index}
        isAnimating={isAnimating}
        isPreview={isPreview}
        {...subOffer}
      />
    </StyledSubOfferWrapper>
  );
};
